import pluralize from 'pluralize'
import {TextInput} from '@primer/react'
import type {EditablePreview} from '../types'
import {useUpdatePreviews} from '../contexts/UpdatePreviewsContext'

export type PreviewProps = {
  preview: EditablePreview
}

export function Preview({preview}: PreviewProps) {
  const {setRulesetName} = useUpdatePreviews()
  const rulesetCount = preview.rulesets.length

  if (preview.isFullyCovered) {
    return <i className="color-fg-muted">Already covered by an existing ruleset</i>
  }
  if (rulesetCount === 0) {
    return <i className="color-fg-muted">No rulesets would be created</i>
  }

  return (
    <div className="d-flex flex-column gap-1">
      <span className="color-fg-muted">
        {rulesetCount} {pluralize('ruleset', rulesetCount)}
      </span>
      {preview.rulesets.map((ruleset, index) => (
        <TextInput
          value={ruleset.name}
          key={ruleset.title}
          aria-label={`Ruleset name for ${ruleset.title}`}
          onChange={ev => {
            setRulesetName({
              id: preview.id,
              rulesetIndex: index,
              newRulesetName: ev.target.value,
            })
          }}
        />
      ))}
    </div>
  )
}
